/*  eslint-disable */
import React, { useLayoutEffect, useRef, useState, KeyboardEvent } from 'react';

import {
  AccordionSummary,
  Button,
  IconButton,
  AccordionDetails,
  Paper,
  Tooltip,
  SvgIcon,
  TextField,
} from '@material-ui/core';

import {
  SelectionState,
  DataTypeProvider,
  TableColumnWidthInfo,
  PagingState,
  CustomPaging,
  Sorting,
  SortingState,
  IntegratedSelection,
} from '@devexpress/dx-react-grid';

import MuiAccordion from '@material-ui/core/Accordion';
import GetAppIcon from '@material-ui/icons/GetApp';
import {
  Table,
  Grid,
  TableHeaderRow,
  PagingPanel,
  TableColumnReordering,
  TableColumnResizing,
} from '@devexpress/dx-react-grid-material-ui';
import { ReactComponent as SvgSortIcon } from 'assets/sorticon.svg';
import Loading from 'components/atoms/Loading';

import PhonelinkLockIcon from '@material-ui/icons/PhonelinkLock';
import ErrorIcon from '@material-ui/icons/Error';
import Brightness1 from '@material-ui/icons/Brightness1';
import CachedIcon from '@material-ui/icons/Cached';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import EventIcon from '@material-ui/icons/Event';
import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';

import dayjs from 'dayjs';
import { PatchedTableSelection } from 'components/atoms/CustomGridComponents/Table';
import { colors } from 'styles/colors';
import { Hide } from 'components';
import { useAuth } from 'hooks/useAuth';
import { GROUPS } from 'constants/permissions';

import {
  postCancelDailyBulletin,
  deleteDailyBulletin,
  postUpdatebulletinStatus,
  postObservationField,
} from 'services/daily-bulletin';

import GridModalCancel from 'components/molecules/GridModalCancel';
import GridModalDelete from 'components/molecules/GridModalDelete';
import WrapperWithTooltip from 'components/atoms/WrapperWithTooltip';

import { DataTypeFormatters } from 'components/atoms/CustomGridComponents/DataTypeProvider';

import { ButtonGroup } from '@mui/material';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';

import { useFarolStatusContext } from 'context/FarolStatusContext';
import {
  ModalFinish,
  ModalStart,
  ModalPause,
  ModalUnpause,
  ModalAdd,
} from './components';
import useStyles from './style';
import { IGrid, IRow } from './types';
import ModalReplanningBulletin from '../DailyBulletinGrid/components/ModalReplanningBulletin';

const tableMessages = {
  noData: 'Sem dados disponíveis',
};

const pagingPanelMessages = {
  showAll: 'Todos',
  rowsPerPage: 'Linhas por página',
  info: ({ from, to, count }) => `${from}-${to} de ${count}`,
};

const DailyBulletinGrid = ({
  columns,
  orderOfColumns,
  rows,
  isRowEnabled,
  loading,
  getRowId,
  pageSize,
  pageSizes,
  onSaveGridConfiguration,
  totalCount,
  onPageSizeChange,
  currentPage,
  onCurrentPageChange,
  refetch,
  getRowById,
  tooltipMaxStrLength,
  tooltipCells = [],
  statusCells = [],
  statusCells2 = [],
  dayMonthTimeCells = [],
  expandAccordion,
  setExpandAccordion,
  onExport,
  onPdf,
  onSortingChange,
}: IGrid) => {
  const classes = useStyles();
  const { checkPermissions } = useAuth();
  const [modalReplan, setModalReplan] = React.useState<boolean>(false);
  const [modalPlan, setModalPlan] = useState<boolean>(false);

  const [columnOrder, setColumnOrder] = useState(orderOfColumns);
  const [openModalPause, setOpenModalPause] = React.useState<boolean>(false);
  const [openModalFinish, setOpenModalFinish] = React.useState<boolean>(false);
  const [openModalStart, setOpenModalStart] = React.useState<boolean>(false);
  const [openModalCancel, setOpenModalCancel] = React.useState<boolean>(false);
  const [selection, setSelection] = React.useState<(string | number)[]>([]);
  const [modalUnpause, setModalUnpause] = React.useState<boolean>(false);
  const [modalDelete, setModalDelete] = React.useState<boolean>(false);
  const [modalAdd, setModalAdd] = React.useState<boolean>(false);
  const [modalStarInspection, setModalStartInspection] =
    React.useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [statusButton, setStatusButton] = React.useState([]);
  const gridRef = useRef<HTMLElement>();
  const scrollDivRef = useRef<HTMLDivElement>(null);
  const hiddenScrollDivRef = useRef<HTMLDivElement>(null);
  const { setFarolStatus } = useFarolStatusContext();

  const sorting = React.useMemo<Sorting[]>(
    () =>
      columns.map(column => {
        return {
          columnName: column.name,
          direction: column.direction,
        } as Sorting;
      }),
    [columns],
  );

  const editingStateColumnExtensions = React.useMemo(
    () =>
      columns.map(column => {
        return {
          columnName: column.name,
          editingEnabled: Boolean(column?.editingEnabled),
        };
      }),
    [columns],
  );

  const [columnWidths, setColumnWidths] = useState<TableColumnWidthInfo[]>(
    columns.map(column => {
      return {
        columnName: column.name,
        width: column.width,
      } as TableColumnWidthInfo;
    }),
  );

  const SortingIcon = React.useCallback(
    () => <SvgIcon component={SvgSortIcon} />,
    [],
  );

  const sortColumnsData = React.useMemo(() => {
    const columnsData = {};

    columns.forEach(({ name, sortingEnabled }) => {
      columnsData[name] = sortingEnabled;
    });
    return columnsData;
  }, [columns]);

  const renderSortLabel = React.useCallback(
    ({ children, onSort, column }) => {
      return (
        <>
          {children}
          {sortColumnsData[column.name] && (
            <IconButton
              className={classes.iconButtonContainer}
              onClick={onSort}
            >
              <SortingIcon />
            </IconButton>
          )}
        </>
      );
    },
    [SortingIcon, classes.iconButtonContainer, sortColumnsData],
  );

  const TooltipFormatter = React.useCallback(
    ({ value }: { value: string }) => {
      const maxLength = tooltipMaxStrLength || 50;

      if (value.length >= maxLength) {
        const trucatedValue = `${value.substring(0, maxLength)}...`;

        return (
          <Tooltip
            classes={{ tooltip: classes.tooltipCenterContent }}
            title={<span className={classes.tooltipLabel}>{value}</span>}
          >
            <span>{trucatedValue}</span>
          </Tooltip>
        );
      }

      return value;
    },
    [classes.tooltipCenterContent, classes.tooltipLabel, tooltipMaxStrLength],
  );

  const CellTooltip = React.useCallback(
    props => (
      <DataTypeProvider
        for={tooltipCells}
        formatterComponent={TooltipFormatter}
        {...props}
      />
    ),
    [TooltipFormatter, tooltipCells],
  );

  const StatusFormatter = React.useCallback(
    ({ row }) => {
      const {
        bulletinStatus,
        activityPlanId,
        activityDiverseId,
        maintenanceType,
        observationField,
      } = row;
      const STATUS_ICON_MAP = {
        Parada: (
          <Button
            color="primary"
            onClick={() =>
              changeStatus(
                'Operacao',
                activityPlanId,
                activityDiverseId,
                maintenanceType,
                observationField,
              )
            }
            title="Create new row"
          >
            <Brightness1 style={{ color: '#ff00009e', marginBottom: '-5px' }} />
          </Button>
        ),
        Operacao: (
          <Button
            color="primary"
            onClick={() =>
              changeStatus(
                'Andamento',
                activityPlanId,
                activityDiverseId,
                maintenanceType,
                observationField,
              )
            }
            title="Create new row"
          >
            <Brightness1 style={{ color: '#008000a7', marginBottom: '-5px' }} />
          </Button>
        ),
        Andamento: (
          <Button
            color="primary"
            onClick={() =>
              changeStatus(
                'Parada',
                activityPlanId,
                activityDiverseId,
                maintenanceType,
                observationField,
              )
            }
            title="Create new row"
          >
            <Brightness1 style={{ color: '#ffff00a0', marginBottom: '-5px' }} />
          </Button>
        ),
      };

      const Icon = STATUS_ICON_MAP[bulletinStatus] || (
        <ErrorIcon className={colors.statusCancelError} />
      );

      if (!isRowEnabled(row)) {
        return (
          <Tooltip
            title={
              <span className={classes.tooltipLabel}>{bulletinStatus}</span>
            }
          >
            <PhonelinkLockIcon className={colors.statusMobile} />
          </Tooltip>
        );
      }
      return (
        <Tooltip
          title={<span className={classes.tooltipLabel}>{bulletinStatus}</span>}
        >
          {Icon}
        </Tooltip>
      );
    },
    [classes.tooltipLabel, isRowEnabled],
  );

  const changeStatus = (
    bulletinStatus,
    activityPlanId,
    activityDiverseId,
    maintenanceType,
    observationField,
  ) => {
    setIsLoading(true);
    const plannedActivitiesToUpdate: any = [];

    const plannedActivitiesToUpdate2 = {
      activityPlanId: Number(activityPlanId),
      activityDiverseId: Number(activityDiverseId),
      bulletinStatus: bulletinStatus,
      maintenanceType: maintenanceType,
      observationField: observationField,
    };
    plannedActivitiesToUpdate.push(plannedActivitiesToUpdate2);

    const params = {
      plannedActivitiesToUpdate,
    };

    postUpdatebulletinStatus(params)
      .then(response => {
        if (response.statusCode === 200) {
          setIsLoading(false);
          setFarolStatus(true);
          if (refetch) refetch();
        }
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {});
  };

  const CellStatus = React.useCallback(
    props => (
      <DataTypeProvider
        for={statusCells}
        formatterComponent={StatusFormatter}
        {...props}
      />
    ),
    [StatusFormatter, statusCells],
  );

  const CellStatus2 = React.useCallback(
    props => (
      <DataTypeProvider
        for={statusCells2}
        formatterComponent={({ row: { status } }) => {
          const iconMap = {
            Cancelado: (
              <ErrorIcon style={{ color: colors.statusCancelError }} />
            ),
            Pausado: (
              <PauseCircleFilledIcon style={{ color: colors.statusPaused }} />
            ),
            Atrasado: (
              <ReportProblemIcon style={{ color: colors.lateStatus }} />
            ),
            Concluído: (
              <CheckCircleIcon style={{ color: colors.statusCompleted }} />
            ),
            'Em andamento': (
              <CachedIcon style={{ color: colors.statusInProgress }} />
            ),
            Programado: (
              <EventIcon style={{ color: colors.statusProgrammed }} />
            ),
            default: <ErrorIcon style={{ color: colors.statusCancelError }} />,
          };

          return DataTypeFormatters.StatusCellFormatter({
            status,
            iconMap,
          });
        }}
        {...props}
      />
    ),
    [statusCells2],
  );

  const DateMonthTimeFormatter = React.useCallback(
    ({ value }: { value: string }) => {
      const data = dayjs(value);
      // horas inseridas pela carga com divergência na hora
      if (data.hour() >= 21 && data.minute() === 0) {
        // return dayjs(value).add(3, 'hour').format('DD/MM HH:mm');
      }
      const datacorreta = dayjs(value).format('DD/MM HH:mm');

      return datacorreta;
    },
    [],
  );
  const updateColumnOrder = React.useCallback(
    colsOrder => {
      setColumnOrder(colsOrder);

      onSaveGridConfiguration({
        order: colsOrder,
        columns: columnWidths,
      });
    },
    [columnWidths, onSaveGridConfiguration],
  );
  const CellDateMonthTime = React.useCallback(
    props => (
      <DataTypeProvider
        for={dayMonthTimeCells}
        formatterComponent={DateMonthTimeFormatter}
        {...props}
      />
    ),
    [DateMonthTimeFormatter, dayMonthTimeCells],
  );

  const renderRow = React.useCallback(
    props => {
      const {
        highlighted,
        tableRow: { row },
      } = props;

      if (!isRowEnabled(row)) {
        return <Table.Row {...props} className={classes.disabledRow} />;
      }

      return (
        <Table.Row
          {...props}
          className={highlighted ? classes.selectedRows : null}
        />
      );
    },
    [classes.disabledRow, classes.selectedRows, isRowEnabled],
  );

  const disabledSelectionButtons = React.useMemo(() => {
    // a linha só é habilitada quando tem uma apenas 1 linha selecionada
    return !(selection?.length === 1);
  }, [selection]);

  const getFirstSelectedRow = React.useMemo(() => {
    if (disabledSelectionButtons) return null;

    const rowId = selection[0];
    const row = getRowById(rowId);

    return row || null;
  }, [disabledSelectionButtons, getRowById, selection]);

  const getSelectedRows = React.useMemo(() => {
    return selection.map(rowId => {
      return getRowById(rowId) as IRow;
    });
  }, [getRowById, selection]);

  const disablePauseButton = React.useMemo(() => {
    // o botão pausar será desabilitado se existir mais de 1 linha selecionada
    // OU existir valor para a coluna término real
    // OU não existir valor para a coluna realStart
    // OU possui valor para a coluna pauseStart E não possuir o valor da coluna de pauseEnd
    // OU o status for igual a Pausado.
    return (
      Boolean(disabledSelectionButtons) ||
      Boolean(getFirstSelectedRow?.realCompletion) ||
      !getFirstSelectedRow?.realStart ||
      Boolean(
        getFirstSelectedRow?.pauseStart && !getFirstSelectedRow?.pauseEnd,
      ) ||
      getFirstSelectedRow?.status === 'Pausado' ||
      getFirstSelectedRow?.status === 'Concluído' || 
      getFirstSelectedRow?.maintenanceType === 'Diversas'
    );
  }, [
    disabledSelectionButtons,
    getFirstSelectedRow?.realCompletion,
    getFirstSelectedRow?.realStart,
    getFirstSelectedRow?.pauseStart,
    getFirstSelectedRow?.pauseEnd,
    getFirstSelectedRow?.status,
    getFirstSelectedRow?.maintenanceType === 'Diversas',
  ]);
  const renderTitleComponent = React.useCallback(
    props => {
      const { children } = props;
      const columnData = columns.find(column => column.title === children);

      if (columnData?.fullTitle) {
        const renderTitle = () => (
          <span className={classes.tooltipLabel}>{columnData?.fullTitle}</span>
        );

        return (
          <TableHeaderRow.Title className={classes.tableTitle} {...props}>
            <Tooltip title={renderTitle()}>
              <span>{children}</span>
            </Tooltip>
          </TableHeaderRow.Title>
        );
      }

      return <TableHeaderRow.Title className={classes.tableTitle} {...props} />;
    },
    [classes.tableTitle, classes.tooltipLabel, columns],
  );

  const disabledSelectionButtonsSeveral = React.useMemo(() => {
    return selection?.length < 1;
  }, [selection]);

  const disableReplanButton = React.useMemo(() => {
    return (
      Boolean(disabledSelectionButtonsSeveral) ||
      getSelectedRows.some(row => row?.status === 'Cancelado' || row?.realStart)
    );
  }, [disabledSelectionButtonsSeveral, getSelectedRows]);

  useLayoutEffect(() => {
    const rootBase = gridRef?.current?.firstChild; // Obtem o elemento RootBase da Grid
    const tableRootContainer = rootBase?.firstChild as HTMLElement; // Container da Tabela para adicionar o evento de scroll horizontal
    const tableOuterDiv = tableRootContainer?.firstChild; // O componente gera uma div pura entre a tabela e o seu container
    const table = tableOuterDiv?.firstChild as HTMLElement; // Elemento da tabela para obter a sua largura

    const hiddenScrollDiv = hiddenScrollDivRef.current as HTMLElement; // Elemento dentro da div externa que possuirá o mesmo tamanho da tabela para scroll externo
    hiddenScrollDiv.style.width = `${table?.offsetWidth + 85}px`; // Atribui a largura da tabela + 85px da Coluna de Checkbox

    const scrollDiv = scrollDivRef.current as HTMLElement; // Elemento onde será colocado o scroll externo

    // Função que será executada ao rolar o scroll externo
    const scrollListener = ({ target }) => {
      const currentScroll = target as HTMLElement;
      tableRootContainer.scrollLeft = currentScroll.scrollLeft; // Scroll da tabela reflete a posição do scroll externo
    };
    scrollDiv.removeEventListener('scroll', scrollListener); // Quando a largura do grid mudar, remover o listener antes de adicionar um novo
    scrollDiv.addEventListener('scroll', scrollListener); // Adicionar o listener para o scroll externo

    return () => scrollDiv.removeEventListener('scroll', scrollListener); // Remover listener ao desmontar o componente
  }, [columnWidths]); // Observar a mudança da largura do grid

  const disabledSelectionsButtons = React.useMemo(() => {
    // a linha só é habilitada quando tem 1 linha ou mais selecionadas
    return selection?.length === 0;
  }, [selection]);

  const disableCancelButton = React.useMemo(() => {
    return (
      disabledSelectionsButtons ||
      getSelectedRows.some(
        row =>
          Boolean(row?.realCompletion) ||
          row?.status === 'Concluído' ||
          row?.status === 'Cancelado' ||
          row?.maintenanceType === 'Diversas',
      )
    );
  }, [disabledSelectionsButtons, getSelectedRows]);

  const disableFinishButton = React.useMemo(() => {
    return (
      disabledSelectionsButtons ||
      getSelectedRows.some(
        row =>
          Boolean(row?.realCompletion) ||
          Boolean(row?.realEnd) ||
          row?.status === 'Cancelado' ||
          row?.status === 'Pausado' ||
          row?.isInspection === 'S' ||
          row?.status === 'Concluído',
      )
    );
  }, [disabledSelectionsButtons, getSelectedRows]);

  const disableStartButton = React.useMemo(() => {
    return (
      selection?.length !== 1 ||
      getSelectedRows.some(
        row =>
          Boolean(row?.realCompletion) ||
          Boolean(row?.realStart) ||
          row?.status === 'Cancelado',
      )
    );
  }, [getSelectedRows, selection?.length]);

  const disableUnpauseButton = React.useMemo(() => {
    // o botão retomar será desabilitado se existir mais de 1 linha selecionada
    // OU existir valor para a coluna término real
    // OU o status for diferente de "Pausado"
    return (
      Boolean(disabledSelectionButtons) ||
      Boolean(getFirstSelectedRow?.realCompletion) ||
      getFirstSelectedRow?.status !== 'Pausado' ||
      getFirstSelectedRow?.maintenanceType === 'Diversas'
    );
  }, [
    disabledSelectionButtons,
    getFirstSelectedRow?.realCompletion,
    getFirstSelectedRow?.status,
    getFirstSelectedRow?.maintenanceType === 'Diversas',
  ]);

  const disableDeleteButton = React.useMemo(() => {
    return (
      disabledSelectionsButtons ||
      getSelectedRows.some(
        row => Boolean(row?.realStart) || Boolean(row?.realCompletion),
      )
    );
  }, [disabledSelectionsButtons, getSelectedRows]);

  const startInspection = React.useMemo(() => {
    return getFirstSelectedRow?.isInspection === 'S';
  }, [getFirstSelectedRow?.isInspection]);

  // const queryClient = useQueryClient();

  const updateColumnWidth = React.useCallback(
    colsWidth => {
      setColumnWidths(colsWidth);

      onSaveGridConfiguration({
        order: columnOrder,
        columns: colsWidth,
      });
    },
    [columnOrder, onSaveGridConfiguration],
  );

  React.useEffect(() => {
    // obtendo todos os ids das linhas da grid
    const rowIds = rows.map(row => getRowId(row));

    /**
     * Atualizo a lista de seleções para corresponder
     * apenas as linhas que estão sendo exibidas.
     */
    setSelection(currentValues => {
      return currentValues.filter(item => rowIds.includes(item));
    });
  }, [getRowId, rows]);
  // React.useEffect(() => {
  //   setInterval(() => {
  //     queryClient.invalidateQueries();
  //   }, 60 * 1000);
  // }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    // Atualiza a ordem das colunas
    setColumnOrder(orderOfColumns);
  }, [orderOfColumns]);

  const handleButton = event => {
    setStatusButton(event.currentTarget.id);
  };

  React.useEffect(() => {
    const fetchTypeButton = async () => {
      const plannedActivitiesToUpdate = getSelectedRows.map(row => ({
        activityPlanId: Number(row.activityPlanId),
        activityDiverseId: Number(row.activityDiverseId),
        bulletinStatus: statusButton,
        maintenanceType: row.maintenanceType,
        observationField: row.observationField,
      }));

      const params = {
        plannedActivitiesToUpdate,
      };

      if (statusButton.length > 0) {
        setIsLoading(true);
        const data = await postUpdatebulletinStatus(params)
          .then(response => {
            if (response.statusCode === 200) {
              setIsLoading(false);
              setFarolStatus(true);
              setIsLoading(false);
              if (refetch) refetch();
            }
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {});
        const resultData = data;
        return resultData;
      }
    };
    fetchTypeButton();
  }, [statusButton]);

  const saveObservationField = (row, newValue) => {
    setIsLoading(true);
    const plannedActivitiesToUpdate = {
      activityPlanId: Number(row.activityPlanId),
      activityDiverseId: Number(row.activityDiverseId),
      bulletinStatus: row.bulletinStatus,
      maintenanceType: row.maintenanceType,
      observationField: newValue,
    };

    const params = {
      plannedActivitiesToUpdate: [plannedActivitiesToUpdate],
    };

    postObservationField(params)
      .then(response => {
        if (response.statusCode === 200) {
          setIsLoading(false);
          // setFarolStatus(true);
          if (refetch) refetch();
        }
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        // Do nothing
      });
  };

  const onkeyPressEnter = React.useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>, row) => {
      if (event.key === 'Enter') {
        saveObservationField(row, (event.target as HTMLInputElement).value);
      }
    },
    [],
  );

  return (
    <MuiAccordion
      className={classes.accordionContainer}
      square
      expanded={expandAccordion}
    >
      <AccordionSummary
        className={classes.accordionSummary}
        aria-controls="bulletin-grid-accordion"
      >
        <div className={classes.buttonsActionsContainer}>
          <div className={classes.buttonsActionsContainerLeft}>
            <Button
              onClick={() => setExpandAccordion(oldValue => !oldValue)}
              color="primary"
            >
              {expandAccordion
                ? 'Ocultar Boletim Diário'
                : 'Ver Boletim Diário'}
            </Button>
          </div>
          <div className={classes.buttonsActionsContainerRight}>
            <Hide
              hide={
                !checkPermissions([
                  GROUPS.ADMINISTRATOR,
                  GROUPS.ENGINEERING,
                  GROUPS.PLANNING,
                  GROUPS.TECHNICIAN,
                ])
              }
            >
              <WrapperWithTooltip
                condition={getSelectedRows.length < 1}
                tooltipMessage="Selecione uma atividade para que o status seja alterado."
              >
                <ButtonGroup
                  color="primary"
                  aria-label="outlined primary button group"
                  className={classes.buttonGroup}
                  disabled={getSelectedRows.length < 1}
                >
                  <Button
                    className={`${classes.button}`}
                    title="Parada"
                    id="Parada"
                    onClick={e => handleButton(e)}
                    disabled={getSelectedRows.length < 1 || isLoading === true}
                  >
                    {/* Par */}
                    <FiberManualRecordIcon className={classes.redStatus} />
                  </Button>

                  <Button
                    className={`${classes.button}`}
                    title="Andamento"
                    id="Andamento"
                    onClick={e => handleButton(e)}
                    disabled={getSelectedRows.length < 1 || isLoading === true}
                  >
                    <FiberManualRecordIcon className={classes.yellowStatus} />
                  </Button>

                  <Button
                    className={`${classes.button}`}
                    title="Em operação"
                    id="Operacao"
                    onClick={e => handleButton(e)}
                    disabled={getSelectedRows.length < 1 || isLoading === true}
                  >
                    <FiberManualRecordIcon className={classes.greenStatus} />
                  </Button>
                </ButtonGroup>
              </WrapperWithTooltip>
            </Hide>
            {/* </div> */}
            <Hide
              hide={
                !checkPermissions([
                  GROUPS.ADMINISTRATOR,
                  GROUPS.ENGINEERING,
                  GROUPS.PLANNING,
                  GROUPS.TECHNICIAN,
                ])
              }
            >
              {/* <ModalStartInspection
                open={modalStarInspection}
                onClose={() => setModalStartInspection(false)}
                gridRow={getFirstSelectedRow}
              > */}
              <ModalStart
                open={openModalStart}
                onClose={() => setOpenModalStart(false)}
                selectedRow={getFirstSelectedRow}
                reloadData={refetch}
              >
                <WrapperWithTooltip
                  condition={getSelectedRows.some(
                    row =>
                      Boolean(row?.realCompletion) ||
                      Boolean(row?.realStart) ||
                      Boolean(row?.status === 'Cancelado'),
                  )}
                  tooltipMessage="Não é possível iniciar uma atividade com data de início real, término real ou com status de cancelada"
                >
                  <Button
                    onClick={() => {
                      if (startInspection) {
                        setModalStartInspection(true);
                      } else {
                        setOpenModalStart(true);
                      }
                    }}
                    disabled={disableStartButton || isLoading === true}
                    color="primary"
                  >
                    Iniciar
                  </Button>
                </WrapperWithTooltip>
              </ModalStart>
              {/* </ModalStartInspection> */}
            </Hide>

            <Hide
              hide={
                !checkPermissions([
                  GROUPS.ADMINISTRATOR,
                  GROUPS.ENGINEERING,
                  GROUPS.PLANNING,
                  GROUPS.TECHNICIAN,
                ])
              }
            >
              <ModalFinish
                open={openModalFinish}
                onClose={() => setOpenModalFinish(false)}
                selectedRows={getSelectedRows}
                reloadData={refetch}
              >
                <WrapperWithTooltip
                  condition={getSelectedRows.some(
                    row =>
                      Boolean(row?.realCompletion) ||
                      Boolean(row?.realEnd) ||
                      Boolean(row?.status === 'Pausado') ||
                      Boolean(row?.status === 'Cancelado'),
                  )}
                  tooltipMessage="Não é possível concluir uma atividade com data de término real ou com status de cancelada/pausada"
                >
                  <WrapperWithTooltip
                    condition={getSelectedRows.some(
                      row =>
                        row?.isInspection === 'S' &&
                        (!row?.realCompletion || !row?.realEnd),
                    )}
                    tooltipMessage="Inspeções precisam ser realizadas para serem concluídas."
                  >
                    <Button
                      onClick={() => setOpenModalFinish(true)}
                      disabled={disableFinishButton || isLoading === true}
                      color="primary"
                    >
                      Concluir
                    </Button>
                  </WrapperWithTooltip>
                </WrapperWithTooltip>
              </ModalFinish>
            </Hide>
            <Hide
              hide={
                !checkPermissions([
                  GROUPS.ADMINISTRATOR,
                  GROUPS.ENGINEERING,
                  GROUPS.PLANNING,
                  GROUPS.TECHNICIAN,
                ])
              }
            >
              <ModalReplanningBulletin
                open={modalReplan}
                onClose={() => setModalReplan(false)}
                selectedRows={getSelectedRows}
                reloadData={refetch}
              >
                <Button
                  disabled={disableReplanButton}
                  color="primary"
                  onClick={() => setModalReplan(true)}
                >
                  Replanejar
                </Button>
              </ModalReplanningBulletin>
            </Hide>

            <Hide
              hide={
                !checkPermissions([
                  GROUPS.ADMINISTRATOR,
                  GROUPS.ENGINEERING,
                  GROUPS.PLANNING,
                  GROUPS.TECHNICIAN,
                ])
              }
            >
              <ModalPause
                open={openModalPause}
                onClose={() => setOpenModalPause(false)}
                gridRow={getFirstSelectedRow}
                reloadData={refetch}
              >
                <Button
                  onClick={() => setOpenModalPause(true)}
                  disabled={disablePauseButton || isLoading === true}
                  color="primary"
                >
                  Pausar
                </Button>
              </ModalPause>
            </Hide>
            <Hide
              hide={
                !checkPermissions([
                  GROUPS.ADMINISTRATOR,
                  GROUPS.TECHNICIAN,
                  GROUPS.PLANNING,
                  GROUPS.ENGINEERING,
                ])
              }
            >
              <ModalUnpause
                open={modalUnpause}
                onClose={() => setModalUnpause(false)}
                gridRow={getFirstSelectedRow}
                reloadData={refetch}
              >
                <Button
                  onClick={() => setModalUnpause(true)}
                  disabled={disableUnpauseButton || isLoading === true}
                  color="primary"
                >
                  Retomar
                </Button>
              </ModalUnpause>
            </Hide>
            <Hide
              hide={
                !checkPermissions([
                  GROUPS.ADMINISTRATOR,
                  GROUPS.TECHNICIAN,
                  GROUPS.PLANNING,
                  GROUPS.ENGINEERING,
                ])
              }
            >
              <ModalAdd
                open={modalAdd}
                onClose={() => setModalAdd(false)}
                reloadData={refetch}
              >
                <Button onClick={() => setModalAdd(true)} color="primary">
                  Adicionar
                </Button>
              </ModalAdd>
            </Hide>
            <GridModalCancel
              open={openModalCancel}
              onClose={() => setOpenModalCancel(false)}
              selectedRows={getSelectedRows}
              reloadData={refetch}
              cancelService={postCancelDailyBulletin}
            >
              <WrapperWithTooltip
                condition={getSelectedRows.some(
                  row =>
                    Boolean(row?.realCompletion) ||
                    row?.maintenanceType === 'Diversas',
                )}
                tooltipMessage="Não é possível cancelar uma atividade finalizada ou do tipo Diversas"
              >
                <Button
                  onClick={() => setOpenModalCancel(true)}
                  disabled={disableCancelButton || isLoading === true}
                  color="primary"
                >
                  Cancelar
                </Button>
              </WrapperWithTooltip>
            </GridModalCancel>
            <Hide
              hide={!checkPermissions([GROUPS.ADMINISTRATOR, GROUPS.PLANNING])}
            >
              <GridModalDelete
                open={modalDelete}
                onClose={() => setModalDelete(false)}
                selectedRows={getSelectedRows}
                service={deleteDailyBulletin}
                reloadData={refetch}
                idKey="activityPlanId"
                idPlan="activityPlanId"
                idReal="activityRealId"
                idDiverse="activityDiverseId"
              >
                <WrapperWithTooltip
                  condition={getSelectedRows.some(
                    row =>
                      Boolean(row?.realStart) || Boolean(row?.realCompletion),
                  )}
                  tooltipMessage="Não é possível excluir uma atividade com data de início real ou término real"
                >
                  <Button
                    onClick={() => setModalDelete(true)}
                    disabled={disableDeleteButton}
                    color="secondary"
                  >
                    Excluir
                  </Button>
                </WrapperWithTooltip>
              </GridModalDelete>
            </Hide>
            <IconButton onClick={onExport}>
              <Tooltip
                title={
                  <span className={classes.tooltipLabel}>Exportar Dados</span>
                }
              >
                <GetAppIcon color="primary" />
              </Tooltip>
            </IconButton>
            <IconButton onClick={onPdf}>
              <Tooltip
                title={
                  <span className={classes.tooltipLabel}>
                    Exportar Dados em PDF
                  </span>
                }
              >
                <PictureAsPdfIcon color="primary" />
              </Tooltip>
            </IconButton>
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <Paper variant="elevation" elevation={0} className={classes.container}>
          <Grid columns={columns} rows={rows} getRowId={getRowId}>
            <SelectionState
              selection={selection}
              onSelectionChange={setSelection}
            />
            <SortingState sorting={sorting} onSortingChange={onSortingChange} />
            <IntegratedSelection />
            {/* <PatchedIntegratedSelection rowSelectionEnabled={isRowEnabled} /> */}
            <CellTooltip />
            {/* <CellYesOrNot /> */}
            <CellDateMonthTime />
            <CellStatus />
            <CellStatus2 />

            <Table
              messages={tableMessages}
              cellComponent={props => {
                const { column, children, row } = props;
                const cellValue = row[column.name];
                if (column.name === 'observationField') {
                  return (
                    <Table.Cell {...props}>
                      {' '}
                      <TextField
                        InputProps={{ disableUnderline: true }}
                        onKeyUp={(event: KeyboardEvent<HTMLInputElement>) => {
                          onkeyPressEnter(event, row);
                        }}
                        onBlur={event =>
                          saveObservationField(row, event.target.value)
                        }
                        className={classes.editableInput}
                        defaultValue={cellValue || ''}
                      />{' '}
                    </Table.Cell>
                  );
                } else {
                  if (cellValue) {
                    if (
                      !isRowEnabled(row) &&
                      !statusCells.includes(column.name)
                    ) {
                      const title = (
                        <span className={classes.tooltipLabel}>
                          Atividade bloqueada - Mobile
                        </span>
                      );

                      const tooltip = (
                        <Tooltip title={title}>
                          <span>{children}</span>
                        </Tooltip>
                      );

                      return (
                        <Table.Cell {...props} value={cellValue}>
                          {tooltip}
                        </Table.Cell>
                      );
                    }

                    return <Table.Cell {...props} />;
                  }

                  return <Table.Cell {...props}> - </Table.Cell>;
                }
              }}
              columnExtensions={columnWidths}
            />

            <TableColumnResizing
              columnWidths={columnWidths}
              onColumnWidthsChange={updateColumnWidth}
            />
            <TableColumnReordering
              order={columnOrder}
              onOrderChange={updateColumnOrder}
            />

            <TableHeaderRow
              titleComponent={renderTitleComponent}
              showSortingControls
              sortLabelComponent={renderSortLabel}
            />
            <PagingState
              currentPage={currentPage}
              onCurrentPageChange={onCurrentPageChange}
              pageSize={pageSize}
              onPageSizeChange={onPageSizeChange}
            />
            <CustomPaging totalCount={totalCount} />

            <PatchedTableSelection
              highlightRow
              showSelectAll
              rowSelectionEnabled={isRowEnabled}
              rowComponent={renderRow}
            />
            <PagingPanel messages={pagingPanelMessages} pageSizes={pageSizes} />
          </Grid>
          <div ref={scrollDivRef} className={classes.scrollDiv}>
            <div ref={hiddenScrollDivRef} className={classes.hiddenScrollDiv} />
          </div>
          {(loading || isLoading) && <Loading />}
        </Paper>
      </AccordionDetails>
    </MuiAccordion>
  );
};

export default DailyBulletinGrid;
